"use strict";

(function ($) {
  // accept all checkbox
  $(document).on('change', '.legal-accept-all input[type="checkbox"]', function () {
    const isChecked = $(this).is(':checked');
    $(this).closest('.wpforms-form').find('.wpforms-field-layout input[type="checkbox"]').prop('checked', isChecked).trigger('change');
  });

  // hide the static form title once WPForms swaps the form for its confirmation message
  $(document).on('wpformsAjaxSubmitSuccess', function (event) {
    $(event.target).closest('[data-form="inner"]').find('[data-form="title"]').fadeOut(200);
  });

  // youlead
  let submittedData = {};
  $(document).on('wpformsBeforeFormSubmit', '.wpforms-form', function () {
    const $form = $(this);
    if ($form.attr('id') !== 'wpforms-form-21' && !$form.closest('[data-promo="overlay"]').length) {
      return;
    }
    submittedData = {
      firstName: $form.find('input[name="wpforms[fields][8]"]').val(),
      lastName: $form.find('input[name="wpforms[fields][9]"]').val(),
      phone: $form.find('input[name="wpforms[fields][5]"]').val(),
      email: $form.find('input[name="wpforms[fields][6]"]').val(),
      message: $form.find('input[name="wpforms[fields][7]"]').val(),
      consent_1: $form.find('input[name="wpforms[fields][18][]"]').is(':checked') ? 'true' : 'false',
      consent_2: $form.find('input[name="wpforms[fields][19][]"]').is(':checked') ? 'true' : 'false',
      consent_3: $form.find('input[name="wpforms[fields][20][]"]').is(':checked') ? 'true' : 'false',
      consent_4: $form.find('input[name="wpforms[fields][21][]"]').is(':checked') ? 'true' : 'false',
      subject: $form.find('.wpforms-field-hidden input[type="hidden"]').val()
    };
  });
  $(document).on('wpformsAjaxSubmitSuccess', function (event, response) {
    const $form = $(event.target);
    const $promo = $form.closest('[data-promo="overlay"]');
    if ($form.attr('id') !== 'wpforms-form-21' && !$promo.length) {
      return;
    }
    if ($promo.length) {
      $promo.find('.promo').addClass('is-submitted');
      document.dispatchEvent(new CustomEvent('modal-promo:submitted'));
    }
    if (typeof Monitor !== 'undefined' && typeof Monitor.TrackForm === 'function') {
      const defaultSubject = typeof form_strings !== 'undefined' && form_strings.form_default_subject || '';
      const apartmentSubject = !$promo.length && submittedData.subject && submittedData.subject !== defaultSubject ? submittedData.subject : '';
      Monitor.TrackForm('soho', [{
        'yl-name': submittedData.firstName,
        'yl-lastName': submittedData.lastName,
        'yl-phone': submittedData.phone,
        'yl-email': submittedData.email,
        'message': submittedData.message,
        'agreement': submittedData.consent_1,
        'marketing_agreement': submittedData.consent_2,
        'marketing_email_agreement': submittedData.consent_3,
        'marketing_contact_agreement': submittedData.consent_4,
        'investment': 'Lokum Soho',
        'title': ($promo.length ? 'Lokum Soho - zapytanie o promocję' : '') || apartmentSubject || 'Lokum Soho - zapytanie ze strony inwestycji'
      }]);
    }
  });

  // header logos offset
  function offsetPosition() {
    var offsetLeft = $('[data-js="header-logo"]').offset();
    if (offsetLeft) {
      $('html').css('--offset-left', `${offsetLeft.left}px`);
    }
  }
  offsetPosition();
  $(window).resize(offsetPosition);

  // fancybox single image/video lightbox
  $(document).on('click', '[data-fancybox="lightbox"]', function (e) {
    if (typeof Fancybox === 'undefined') return;
    e.preventDefault();
    var type = $(this).data('type') || 'image';
    Fancybox.show([{
      src: $(this).attr('href'),
      type: type,
      caption: $(this).data('caption')
    }], {
      placeFocusBack: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close']
        }
      }
    });
  });

  // Scroll to an Element
  $('[data-js="scroll"]').on('click', function (e) {
    var $el = $(this);
    var $href = $el.attr('href');
    if (!$href || $href.charAt(0) !== '#' || $href.length < 2) {
      return;
    }
    e.preventDefault();
    var $id = $($href);
    if ($id.length > 0) {
      var $currentScrollTop = $(window).scrollTop();
      var $targetScrollTop = $id.offset().top;
      var $offset = 0;
      $targetScrollTop += $offset;
      $('html, body').animate({
        scrollTop: $targetScrollTop
      }, 600);
    }
  });
})(jQuery);
(function () {
  var selector = '[data-js^="slider"]';
  var breakpoint = 1249;
  function shouldEnable() {
    return window.matchMedia('(max-width: ' + breakpoint + 'px)').matches;
  }
  function initSliders() {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.swiperInstance) {
        return;
      }
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        centeredSlides: false,
        watchOverflow: true,
        touchEventsTarget: 'container',
        loop: true,
        speed: 500,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: el.querySelector('[data-slider-pagination]'),
          clickable: true
        },
        navigation: {
          nextEl: el.querySelector('[data-slider-button-next]'),
          prevEl: el.querySelector('[data-slider-button-prev]')
        }
      });
    });
  }
  function destroySliders() {
    document.querySelectorAll(selector).forEach(function (el) {
      if (!el.swiperInstance) {
        return;
      }
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    });
  }
  function updateSliders() {
    if (shouldEnable()) {
      initSliders();
    } else {
      destroySliders();
    }
  }
  updateSliders();
  var rafPending = false;
  window.addEventListener('resize', function () {
    if (rafPending) {
      return;
    }
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      updateSliders();
    });
  });
  window.addEventListener('orientationchange', updateSliders);
})();
(function () {
  var el = document.querySelector('[data-js="sticky-cta"]');
  if (!el) {
    return;
  }
  var threshold = 10;
  var top = null;
  var ticking = false;
  function update() {
    ticking = false;
    var next = window.scrollY <= threshold;
    if (next === top) {
      return;
    }
    top = next;
    el.classList.toggle('is-top', top);
  }
  function onScroll() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(update);
  }
  update();
  window.addEventListener('scroll', onScroll, {
    passive: true
  });
})();

/* toggles .is-on-light / .is-on-dark on [data-theme-watch] */
(function () {
  function initThemeWatch() {
    var targets = document.querySelectorAll('[data-theme-watch]');
    var sections = document.querySelectorAll('[data-theme]');
    if (!targets.length || !sections.length) {
      return;
    }
    var ticking = false;
    function update() {
      for (var t = 0; t < targets.length; t++) {
        var target = targets[t];
        var rect = target.getBoundingClientRect();
        var x = rect.left + rect.width / 2;
        var y = rect.top + rect.height / 2;
        var theme = null;
        for (var s = 0; s < sections.length; s++) {
          var sectionRect = sections[s].getBoundingClientRect();
          if (y >= sectionRect.top && y <= sectionRect.bottom && x >= sectionRect.left && x <= sectionRect.right) {
            theme = sections[s].getAttribute('data-theme');
          }
        }
        if (theme) {
          target.classList.toggle('is-on-light', theme === 'light');
          target.classList.toggle('is-on-dark', theme === 'dark');
        }
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeWatch);
  } else {
    initThemeWatch();
  }
})();
(function () {
  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }
  function initSlider(section) {
    var el = section.querySelector('[data-slider="area"]');
    if (!el || el.swiperInstance) {
      return;
    }
    var photosEl = section.querySelector('[data-slider="area-photos"]');
    var photos = null;
    if (photosEl && !photosEl.swiperInstance) {
      photos = new Swiper(photosEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 300,
        slidesPerView: 1,
        allowTouchMove: false,
        watchOverflow: true
      });
      photosEl.swiperInstance = photos;
    }
    el.swiperInstance = new Swiper(el, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 300,
      slidesPerView: 1,
      rewind: true,
      grabCursor: true,
      watchOverflow: true,
      touchEventsTarget: 'container',
      navigation: {
        prevEl: Array.from(section.querySelectorAll('[data-slider-button-prev="area"]')),
        nextEl: Array.from(section.querySelectorAll('[data-slider-button-next="area"]'))
      },
      pagination: {
        el: section.querySelector('[data-slider-pagination="area"]'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<button type="button" class="' + className + '">' + pad(index + 1) + '</button>';
        }
      },
      on: {
        slideChange: function () {
          if (photos) {
            photos.slideTo(this.activeIndex);
          }
        }
      }
    });
  }
  document.querySelectorAll('[data-js="area"]').forEach(initSlider);
})();
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-js="banner"]');
  if (!section) return;
  const img = section.querySelector('[data-js="banner-photo"]');
  if (!img) return;
  const query = window.matchMedia('(min-width: 768px) and (prefers-reduced-motion: no-preference)');
  function onScroll() {
    const rect = section.getBoundingClientRect();
    const viewH = window.innerHeight;
    const center = rect.top + rect.height / 2;
    const range = viewH / 2 + rect.height / 2;
    const progress = Math.max(-1, Math.min(1, (viewH / 2 - center) / range));
    img.style.transform = 'translateY(' + progress * 450 + 'px)';
  }
  function toggle() {
    if (query.matches) {
      window.addEventListener('scroll', onScroll, {
        passive: true
      });
      window.addEventListener('resize', onScroll);
      onScroll();
    } else {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      img.style.transform = '';
    }
  }
  query.addEventListener('change', toggle);
  toggle();
});
(function () {
  var breakpoint = 768;
  function shouldEnable() {
    return window.matchMedia('(max-width: ' + breakpoint + 'px)').matches;
  }
  function initSliders() {
    document.querySelectorAll('[data-js="flats"]').forEach(function (section) {
      var el = section.querySelector('[data-slider="flats"]');
      if (!el || el.swiperInstance) {
        return;
      }
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,
        touchEventsTarget: 'container',
        loop: true,
        navigation: {
          nextEl: section.querySelector('[data-slider-button-next="flats"]'),
          prevEl: section.querySelector('[data-slider-button-prev="flats"]')
        },
        pagination: {
          el: section.querySelector('[data-slider-pagination="flats"]'),
          type: 'bullets',
          dynamicBullets: true,
          dynamicMainBullets: 3,
          clickable: true
        }
      });
    });
  }
  function destroySliders() {
    document.querySelectorAll('[data-slider="flats"]').forEach(function (el) {
      if (!el.swiperInstance) {
        return;
      }
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    });
  }
  function updateSliders() {
    if (shouldEnable()) {
      initSliders();
    } else {
      destroySliders();
    }
  }
  if (!document.querySelector('[data-js="flats"]')) {
    return;
  }
  function closeFlatModals() {
    document.querySelectorAll('[data-flat-modal="overlay"].is-active').forEach(function (overlay) {
      overlay.classList.remove('is-active');
    });
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-flat-modal="close"]')) {
      closeFlatModals();
      return;
    }
    var card = event.target.closest('[data-flat-modal="open"]');
    if (!card || event.target.closest('[data-modal="open"]')) {
      return;
    }
    var overlay = document.querySelector('[data-flat-modal="overlay"][data-flat-id="' + card.getAttribute('data-flat-target') + '"]');
    if (overlay) {
      overlay.classList.add('is-active');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFlatModals();
    }
  });
  updateSliders();
  var rafPending = false;
  window.addEventListener('resize', function () {
    if (rafPending) {
      return;
    }
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      updateSliders();
    });
  });
  window.addEventListener('orientationchange', updateSliders);
})();
(function () {
  var breakpoint = 1249;
  function shouldEnable() {
    return window.matchMedia('(max-width: ' + breakpoint + 'px)').matches;
  }
  function initSliders() {
    document.querySelectorAll('[data-js="gallery"]').forEach(function (section) {
      var el = section.querySelector('[data-slider="gallery"]');
      if (!el || el.swiperInstance) {
        return;
      }
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,
        touchEventsTarget: 'container',
        loop: true,
        navigation: {
          prevEl: section.querySelector('[data-slider-button-prev="gallery"]'),
          nextEl: section.querySelector('[data-slider-button-next="gallery"]')
        },
        pagination: {
          el: section.querySelector('[data-slider-pagination="gallery"]'),
          type: 'bullets',
          dynamicBullets: true,
          dynamicMainBullets: 3,
          clickable: true
        }
      });
    });
  }
  function destroySliders() {
    document.querySelectorAll('[data-slider="gallery"]').forEach(function (el) {
      if (!el.swiperInstance) {
        return;
      }
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    });
  }
  function updateSliders() {
    if (shouldEnable()) {
      initSliders();
    } else {
      destroySliders();
    }
  }
  function initLightbox() {
    document.querySelectorAll('[data-js="gallery"]').forEach(function (section) {
      section.addEventListener('click', function (event) {
        var link = event.target.closest('[data-fancybox]');
        if (!link || typeof Fancybox === 'undefined') {
          return;
        }
        event.preventDefault();
        var group = link.getAttribute('data-fancybox');
        var links = Array.prototype.slice.call(section.querySelectorAll('[data-fancybox="' + group + '"]'));
        var items = links.map(function (item) {
          return {
            src: item.getAttribute('href'),
            type: item.dataset.type || 'image',
            caption: item.dataset.caption
          };
        });
        Fancybox.show(items, {
          startIndex: links.indexOf(link),
          placeFocusBack: false,
          Toolbar: {
            display: {
              left: [],
              middle: [],
              right: ['close']
            }
          }
        });
      });
    });
  }
  if (!document.querySelector('[data-js="gallery"]')) {
    return;
  }
  updateSliders();
  initLightbox();
  var rafPending = false;
  window.addEventListener('resize', function () {
    if (rafPending) {
      return;
    }
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      updateSliders();
    });
  });
  window.addEventListener('orientationchange', updateSliders);
})();
(function () {
  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }
  function initSlider(section) {
    var el = section.querySelector('[data-slider="localization"]');
    if (!el || el.swiperInstance) {
      return;
    }
    var items = section.querySelectorAll('[data-slider-item="localization"]');
    function setActive(index) {
      items.forEach(function (item, i) {
        var active = i === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
    el.swiperInstance = new Swiper(el, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 300,
      slidesPerView: 1,
      loop: true,
      grabCursor: true,
      watchOverflow: true,
      touchEventsTarget: 'container',
      navigation: {
        prevEl: Array.from(section.querySelectorAll('[data-slider-button-prev="localization"]')),
        nextEl: Array.from(section.querySelectorAll('[data-slider-button-next="localization"]'))
      },
      pagination: {
        el: section.querySelector('[data-slider-pagination="localization"]'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<button type="button" class="' + className + '">' + pad(index + 1) + '</button>';
        }
      },
      on: {
        realIndexChange: function () {
          setActive(this.realIndex);
        }
      }
    });
  }
  document.querySelectorAll('[data-js="localization"]').forEach(initSlider);
})();
(function () {
  var breakpoint = 1249;
  function shouldEnable() {
    return window.matchMedia('(max-width: ' + breakpoint + 'px)').matches;
  }
  function initSliders() {
    document.querySelectorAll('[data-js="map"]').forEach(function (section) {
      var el = section.querySelector('[data-slider="distances"]');
      if (!el || el.swiperInstance) {
        return;
      }
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,
        touchEventsTarget: 'container',
        loop: true,
        navigation: {
          prevEl: section.querySelector('[data-slider-button-prev="distances"]'),
          nextEl: section.querySelector('[data-slider-button-next="distances"]')
        },
        pagination: {
          el: section.querySelector('[data-slider-pagination="distances"]'),
          type: 'bullets',
          clickable: true
        }
      });
    });
  }
  function destroySliders() {
    document.querySelectorAll('[data-slider="distances"]').forEach(function (el) {
      if (!el.swiperInstance) {
        return;
      }
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    });
  }
  function updateSliders() {
    if (shouldEnable()) {
      initSliders();
    } else {
      destroySliders();
    }
  }
  function initLegend() {
    document.querySelectorAll('[data-js="map"]').forEach(function (section) {
      var toggle = section.querySelector('[data-js="legend-toggle"]');
      var list = section.querySelector('[data-legend-list]');
      if (!toggle || !list) {
        return;
      }
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        list.classList.toggle('is-active', !expanded);
      });
    });
  }
  if (!document.querySelector('[data-js="map"]')) {
    return;
  }
  updateSliders();
  initLegend();
  var rafPending = false;
  window.addEventListener('resize', function () {
    if (rafPending) {
      return;
    }
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      updateSliders();
    });
  });
  window.addEventListener('orientationchange', updateSliders);
})();
//# sourceMappingURL=app.js.map
